export default __webpack_public_path__ + "static/media/Group_8419.df5c59ba.svg";